import { render, staticRenderFns } from "./front-menu.vue?vue&type=template&id=1490f92a&scoped=true&"
import script from "./front-menu.vue?vue&type=script&lang=js&"
export * from "./front-menu.vue?vue&type=script&lang=js&"
import style0 from "./front-menu.vue?vue&type=style&index=0&id=1490f92a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1490f92a",
  null
  
)

export default component.exports